var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-cn"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"main-bd mg20"},[_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('SubForm',{key:_vm.sub_form_key,on:{"submit":_vm.submitForm}})],1)],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-hd"},[_c('h4',[_vm._v("创建客户")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7695e48e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/customer-std/create.vue
// module id = 2486
// module chunks = 0